import {
    formatReportColumnLabel,
    formatReportSmartDateTime,
} from "@/utility/fclReportHelpers";
import { isExcludedExportKey, REPORT_EXPORT_EXCLUDE_KEYS } from "@/pages/reports/shared/reportExportData";

const isIsoDateString = (value) =>
    typeof value === "string" &&
    /^\d{4}-\d{2}-\d{2}/.test(value) &&
    !Number.isNaN(Date.parse(value));

export const formatReportCellValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    if (typeof value === "object") {
        try {
            return JSON.stringify(value);
        } catch {
            return String(value);
        }
    }
    if (isIsoDateString(value)) return formatReportSmartDateTime(value);
    return String(value);
};

export const getReportCellSortValue = (row, col) => {
    if (!col) return "";
    if (typeof col.sortValue === "function") return col.sortValue(row);
    const value = row?.[col.key];
    if (value === null || value === undefined) return "";
    if (typeof value === "number") return value;
    if (isIsoDateString(value)) return new Date(value).getTime();
    return String(value).toLowerCase();
};

export const buildReportColumns = (rows = [], options = {}) => {
    const { excludeKeys = [] } = options;
    const skip = new Set([...REPORT_EXPORT_EXCLUDE_KEYS, ...excludeKeys]);
    if (!rows?.length) return [];

    return Object.keys(rows[0])
        .filter((key) => !skip.has(key) && !isExcludedExportKey(key))
        .map((key) => ({
            key,
            label: formatReportColumnLabel(key).toUpperCase(),
            sortable: true,
            render: (row) => formatReportCellValue(row?.[key]),
            sortValue: (row) => getReportCellSortValue(row, { key }),
        }));
};
